var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResturant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-29.2%",
    y: "-15.2%",
    width: "158.3%",
    height: "142.4%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.064576049 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.001 3.118C.001 1.403 1.413 0 3.138 0h17.725C22.588 0 24 1.403 24 3.118v17.615c0 1.714-1.412 3.118-3.138 3.118h-3.813L12 33l-5.05-9.15H3.137C1.412 23.85 0 22.448 0 20.732L.001 3.118z",
    id: "b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.02 .003)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F06F00",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.847 6.074a.366.366 0 0 1 .266.108l9.84 9.839a.672.672 0 1 1-.952.951l-4.611-4.611-1.404 1.404a.705.705 0 0 1-.998 0l-2.394-2.394a3.67 3.67 0 0 1 0-5.19.37.37 0 0 1 .253-.107zm4.664 7.232.952.951-2.606 2.606a.673.673 0 1 1-.951-.951l2.605-2.606zm5.957-7.86a.673.673 0 0 1 0 .952L13.376 9.49a.336.336 0 0 0 .476.475l3.092-3.092a.673.673 0 1 1 .951.952l-3.092 3.092a.336.336 0 1 0 .476.476L18.37 8.3a.672.672 0 1 1 .951.95l-3.33 3.33a1.346 1.346 0 0 1-1.903 0l-.475-.475-.353.353-.952-.951.354-.353-.476-.476a1.345 1.345 0 0 1 0-1.903l3.33-3.33a.673.673 0 0 1 .951 0zM6.006 7.977c-.3.823-.12 1.782.54 2.443l1.94 1.941.952-.951-3.432-3.433z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResturant);
export default __webpack_public_path__ + "static/media/icon-resturant.a67b7a97f27d014a19327faca33fbb63.svg";
export { ForwardRef as ReactComponent };